export default {
  "iso3": "swe",
  "iso2": "sv",
  "text": {
    "100200": "Tyvärr verkar det här spelet vara föremål för restriktioner i din region.",
    "CURRENT_LANGUAGE": "Svenska",
    "CIP8_TITLE": "888CASINO SPEL",
    "Login": "LOGGA IN",
    "WITHDRAW": "UTTAG",
    "CASHIER": "Kassan",
    "Search": "Sök efter spel...",
    "REWARDS": "Belöningar",
    "HOME": "Startsida",
    "888_COM": "888.com",
    "888_POKER": "poker",
    "888_CASINO": "casino",
    "888_BINGO": "bingo",
    "888_SPORT": "sport",
    "SIGN_UP": "BLI MEDLEM",
    "DEPOSIT_SIDE_MENU": "Gör en insättning",
    "MY_ACCOUNT": "MITT KONTO",
    "BALANCE": "Ditt saldo",
    "LOGOUT": "Logga ut",
    "GREETING_MORNING": "God morgon!",
    "GREETING_AFTERNOON": "God eftermiddag!",
    "GREETING_EVENING": "God kväll!",
    "GREETING_NIGHT": "God natt!",
    "GREETING_DEFAULT": "Hej!",
    "MRS_TITLE": "Fru",
    "MR_TITLE": "Herr",
    "SLOTS": "Casino Slots",
    "LOBBY": "Lobby",
    "SLOTS_JACKPOTS": "Slots & Jackpottar",
    "CARD_TABLE_GAMES": "Kort- och bordsspel",
    "CASINO_GAMES": "Casinospel",
    "LIVE_CASINO": "Live Casino",
    "PROMOTIONS": "Kampanjer",
    "888SPORT": "888sport",
    "VIP_CLUB": "VIP",
    "PWA_INSTALL": "Installera app",
    "PWA_ADD_TO_HOME_SCREEN": "Lägg till på startskärmen",
    "PWA_TAP": "Tap",
    "PWA_QUICK_LAUNCH": "Quick launch {BRAND}",
    "BLOG": "Blogg",
    "TODAY_WINNERS": "Dagens vinnare",
    "SUPPORT_ID_MESSAGE": "Support-ID",
    "DEPOSIT": "INSÄTTNING",
    "CHOOSE_LANG": "Välj språk:",
    "CHOOSE_COUNTRY": "Välj land:",
    "SIGN_IN_PLAY": "LOGGA IN OCH SPELA",
    "NEW": "Nyheter",
    "JACKPOT": "Jackpott",
    "BRAND_EXCLUSIVE_FILTER": "Section8",
    "EXCLUSIVE": "Exklusivt på 888",
    "SI_EXCLUSIVE": "Exklusivt på SI ",
    "1-25_LINES": "1-25 vinstlinjer",
    "25+_LINES": "25+ vinstlinjer",
    "888_EXCLUSIVE_GAMES": "Exklusiva 888-spel",
    "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES": "888 exklusiva spel!",
    "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES": "888casino är hem till ett exklusivt urval av onlinekasinospel. Spela de hetaste onlineslotsen från Section8 och njut av fantastiska kasinospel som onlineroulette, onlineblackjack och videopoker. Våra exklusiva kasinospel inkluderar Baccarat, Keno och instantspel. Ställ in dig på att ha kul på vårt kasino!",
    "INFO_TITLE_ARENA_SLOTS": "Casino Slots",
    "INFO_TEXT_ARENA_SLOTS": "Välj bland över 100 av de bästa, mest högklassiga spelautomaterna någonstans online och njut av en rad olika spännande funktioner som bonusspel, expanderande Wild-symboler, free spins och enorma jackpottar. Det spelar ingen roll vilket tema du söker – skattjakt i antikens Egypten, leprechaunens kruka med guld eller helt klassiska fruktsymboler – hos oss hittar du garanterat dina favoritspel.",
    "INFO_TITLE_ARENA_CASINO": "Casinospel",
    "INFO_TEXT_ARENA_CASINO": "Korten är blandade, roulettehjulet snurrar. Hos oss finns det alltid en ledig plats vid spelborden! Här hittar du de bästa kort- och bordsspelen online och kan t.ex. välja mellan olika varianter av roulette som europeisk eller amerikansk liksom låga eller höga insatser eller Super Stakes. Föredrar du Blackjack? Inga problem! Hos oss kan du till och med spela flera givar samtidigt. Vad gäller poker har vi allt från Texas Hold’em till Caribbean, du väljer själv!",
    "INFO_TITLE_ARENA_ROULETTE": "Roulette Online",
    "INFO_TEXT_ARENA_ROULETTE": "Försök pricka in dina turnummer vid ett av 888casinos exklusive onlineroulettebord. Oavsett om du är en high roller eller föredrar låga insatser, har du ett brett utbud av roulettevarianter med bland annat europeisk, amerikansk och fransk roulette. Kort sagt, det finns en variant för alla och det är få saker som är så nervkittlande som att vänta på att kulan ska stanna!",
    "INFO_TITLE_ARENA_NEW_GAMES": "Nya Spel",
    "INFO_TEXT_ARENA_NEW_GAMES": " ",
    "INFO_TITLE_ARENA_BLACKJACK": "Blackjack Online",
    "INFO_TEXT_ARENA_BLACKJACK": "Korten har blandats och det finns en plats ledig vid bordet. På 888casino väntar några av de bästa blackjackspelen som internet har att erbjuda. Hos oss kan du spela helt på dina egna villkor med Super Stakes, sidobets och mycket annat. Räcker det inte med en blackjackhand i taget för dig? I så fall kan vi rekommendera Multihand Blackjack – ett spel där du har tre chanser i varje giv att få 21.",
    "INFO_TITLE_ARENA_VIDEO_POKER": "Video Poker Online",
    "INFO_TEXT_ARENA_VIDEO_POKER": "Om du anser att du är ett riktigt pokerproffs har du kommit helt rätt! På vårt casino kan du jaga den där svårfångade royal flushen i olika versioner av videopoker. Oavsett om du gillar femkorts mörkpoker eller föredrar det ständigt lika populära Texas Hold’em kan du vara lugn! På 888casino hittar du garanterat både gamla och nya nätvideopoker-favoriter.",
    "INFO_TITLE_ARENA_SCRATCH_CARDS": "Skraplotter online",
    "INFO_TEXT_ARENA_SCRATCH_CARDS": "Det är en härlig känsla i de snabba vinsterna i något av 888casinos spännande skraplottsspel. De är perfekta när du bara är sugen på lite strategifri spänning. Det är bara att välja önskat tema för din onlineskraplott, t.ex. Irish Riches eller Pharaoh’s Fortune. Det är helt upp till dig vad du vill utforska och att välja önskad insats. Sedan är det bara att skrapa! Har du turen med dig idag? Har du valt en vinnare?",
    "NETENT_SLOTS": "NETENT-SPELAUTOMATER",
    "BONUS": "Bonus",
    "FREE_SPINS": "Free spins",
    "CLEAR_ALL": "Rensa allt",
    "FILTER": "Filter",
    "APPLY": "Tillämpa",
    "ROULETTE": "Online Roulette",
    "BLACKJACK": "Blackjack",
    "BACCARAT": "Baccarat",
    "POKER": "Poker",
    "KENO": "Keno",
    "HIGH_LIMIT": "Övre gräns",
    "LANGUAGES": "Språk",
    "HELP": "Hjälp",
    "LIVE_CHAT": "Livechatt",
    "DEMO": "Demo",
    "PLAY": "Spela",
    "NOT_NOW": "Inte nu",
    "MAYBE_LATER": "Inte nu",
    "NO_THANKS": "Nej tack",
    "LETS_PLAY": "Då kör vi!",
    "GOT_IT": "GOT IT!",
    "LIMITS": "Gränser",
    "LIVE": "Live",
    "SEE_ALL": "Visa alla",
    "WINNING_IN_THE_LAST_30_DAYS": "Vinster de senaste 30 dagarna",
    "TOTAL_JACKPOTS": "Total jackpottvinst",
    "TOP_GAMES": "POPULÄRA SPELAUTOMATER",
    "LIVE_CASINO_TABLES": "Live Casino",
    "JACKPOTS": "JACKPOTTAR",
    "RECENTLY_PLAYED": "Nyligen spelade",
    "BECAUSE_YOU_PLAYED": "För att du spelade {gameName}",
    "MINIMUM_BET": "Minsta insats",
    "MAXIMUM_BET": "Högsta insats",
    "PAYLINES": "Vinstlinjer",
    "BONUS_GAME": "Bonusspel",
    "MAX_PER_SPOT": "Max per plats",
    "MULTIPLAYER": "Multispelare",
    "DECKS": "Kortlekar",
    "SIDE_BETS": "Sidoinsatser",
    "ABOUT": "Om",
    "GAME_JACKPOT": "Speljackpott",
    "SLOT_GAMES": "Spelautomater",
    "CARD_AND_TABLE_GAMES": "Kort- och bordsspel",
    "JACKPOT_GAMES": "Jackpottspel",
    "JACKPOT_CENTRAL": "Jackpott-spel",
    "OTHER": "Övrigt",
    "POKER_GAMES": "POKERSPEL",
    "YOUR_SEARCH_DID_NOT_MATCH_ANY_GAMES": "Sökningen matchade inga spel",
    "PREMIER_ONLINE_LIVE_CASINO": "Live Casino",
    "All_SLOTS": "Alla spelautomater",
    "All_CARD_AND_TABLE_GAMES": "Alla kort- och bordsspel",
    "USEFUL_LINKS": "Användbara länkar",
    "PRIVACY_POLICY": "Integritetspolicy",
    "USER_AGREEMENT": "Användaravtal",
    "RESPONSIBLE_GAMBLING": "Spela ansvarsfullt",
    "SAFE_ZONE": "Kontrollcenter",
    "CONTACT": "Kontakta oss",
    "COMP_POINTS": "BONUSPOÄNG",
    "GAMING_HISTORY": "Spelhistorik",
    "TIPPING_HISTORY": "Drickshistorik",
    "TIPPING_HISTORY_AMOUNT": "Dricksbelopp",
    "TOP_CASINO_GAMES": "POPULÄRA CASINOSPEL",
    "MY_CHALLENGES": "My Challenges",
    "SCRATCHCARDS": "Skraplotter",
    "QUICK_LINKS_TITLE": "SNABBLÄNKAR",
    "NO_SEARCH_RESULTS": "Inga sökresultat har hittats...",
    "SEARCH_YOUR_GAME": "Sök efter spel...",
    "SEARCH_RESULTS_TITLE": "DE BÄSTA SÖKRESULTATEN",
    "SUGGESTED_GAMES": "FÖRESLAG PÅ SPEL",
    "SUGGESTED_CATEGORIES": "FÖRSLAG PÅ KATEGORIER",
    "BACK": "Tillbaka",
    "OUR_JACKPOTS": "VÅRA JACKPOTTAR",
    "MY_CLUB": "Min klubb",
    "CASH_BALANCE": "Kontantsaldo",
    "BONUS_BALANCE": "Bonussaldo",
    "HIT_THE_JACKPOT": "Spela",
    "YOU_MAY_LIKE": "SE HÄR:",
    "TOP_PICKS_FOR": "FRÄMSTA VAL FÖR {USERNAME}",
    "888CLUB": "888club",
    "888POKER": "888poker",
    "BACK_TO_888POKER": "Tillbaka till 888poker",
    "BACK_TO_888SPORT": "Tillbaka till 888sport",
    "VIDEO_POKER_GAMES": "Videopokerspel ",
    "VIDEO_POKER": "Videopoker",
    "SEO_IMAGE_CATEGORIES_TITLE": "Bästa {categoryName}-upplevelsen på 888casino",
    "SEO_IMAGE_CATEGORIES_ALT": "onlinekasino – {categoryName}",
    "SEO_IMAGE_GAME_TITLE": "{gameName} {categoryName}",
    "LOW_ROLLERS": "Low Rollers",
    "TOP_NETENT_SLOTS": "POPULÄRA NETENT-SPELAUTOMATER",
    "PLAY_50_FREESPINS": "SPELA 50 FREESPINS",
    "HOLIDAY_GAMES": "SPEL FÖR JUL OCH NYÅR",
    "ELITE_LOUNGE": "Elite Lounge",
    "ORIGINALS": "Exklusiva spel på 888",
    "RELATED_GAMES": "EFTERSOM DU VALDE: {gameName}",
    "DAILY_JACKPOT_GAMES": "Daglig jackpottspel",
    "HIGH_VOLATILITY": "Hög Volatilitet",
    "LOW_VOLATILITY": "Små fluktuationer",
    "IN_HOUSE_SLOTS": "Egna spelautomater",
    "MORE_GAMES": "Fler spel",
    "CLASSIC_SLOTS": "KLASSISKA SPELAUTOMATER",
    "ALL_JACKPOTS": "ALLA JACKPOTTAR",
    "POPULAR_GAMES_TITLE": "Populära spel",
    "MORE": "Mer",
    "HOMEPAGE-SPOOKY_SPINS": "Spooky Spins",
    "RED_TIGER_DAILY_JACKPOT_GAMES": "Red Tiger Dagliga Jackpotten",
    "THE_DAILY_JACKPOT": "888 DAGLIGA JACKPOTTEN",
    "HIGH_NOON_JACKPOT": "Lunchjackpott",
    "TWILIGHT_JACKPOT": "Twilight-jackpot",
    "POWER8_JACKPOT": "POWER 8 JACKPOTT",
    "RED_TIGER_DAILY_JACKPOT": "RED TIGER DAGLIGA JACKPOTTEN",
    "RED_TIGER_HOURLY_JACKPOT": "Red Tiger Hourly Jackpot",
    "PROGRESSIVE_JACKPOTS": "PROGRESSIVA JACKPOTTAR",
    "INFO_TITLE_ARENA_JACKPOTS": "Jackpotspel",
    "INFO_TEXT_ARENA_JACKPOTS": "Jackpotspel erbjuder oerhört stora kontantpriser. Bli rik på våra slots – och kortspel och du är hemma. Dessa inkluderar progressiva jackpots, lokala jackpots, delade jackpots och fixerade jackpots. Du är ett klick bort från det perfekta spelet; njut av jackpotspel som Millionaire Genie, Mermaid’s Millions eller Noche De Los Muertos. Klicka dig fram och spinna för att vinna. Det roliga börjar NU!",
    "INSTANT_GAMES": "Spel Med Direkt Vinstchans",
    "INSTANT_WIN_GAMES_ARENA": "Spel Med Direkt Vinstchans",
    "ALL_INSTANT_WIN_GAMES": "ALLA SPEL MED DIREKT VINSTCHANS ",
    "INFO_TITLE_ARENA_INSTANT_WIN_GAMES": "Spel Med Direkt Vinstchans",
    "INFO_TEXT_ARENA_INSTANT_WIN_GAMES": "Instantspel är så ROLIGT! Förbered dig på att skrapa planetens bästa lotter. Vi har flera spel som du kommer gilla som Volcano Eruption, Panda Mania och Merlin’s Millions. Har du ont om tid? Ingen fara, du kan spela våra Keno – och Bingospel, eller nya heta spel som Chicken Extreme, 7-UP och Epic Gems. Vi har fest och du är bjuden. Instantspel är väldigt lätta att spela. Du behöver inte vara duktig – det är bara att spela och vinna!",
    "TRENDING_SLOTS": "POLULÄRA SPELAUTOMATER",
    "EXCLUSIVE_LIVE_TABLES": "EXKLUSIVA LIVE-BORD",
    "BLACKJACK_AND_ROULETTE_GAMES": "BLACKJACK OCH ROULETTE",
    "ALL_888_EXCLUSIVE_GAMES": "ALLA EXKLUSIVA 888-SPEL",
    "LIVE_ARENA_TABLE_IS_CLOSED_MESSAGE": "Bordet öppnar kl.",
    "LIVE_CASINO_TABLE_FULL_PC": "Bordet är fullt",
    "LIVE_CASINO_TABLE_FULL_MOBILE": "Fullt",
    "GAME_SHOWS": "Spel och frågesport",
    "TOP_EVO_GAMES": "Toppspel",
    "FOR_YOU_GAMES": "TILL DIG",
    "LETS_PLAY_MONOPOLY": "Låt oss spela Monopol",
    "TOP_TRENDING_SLOTS": "Populära slots",
    "TOP_PAYING_SLOTS": "Högst betalande slotsen",
    "RECENTLY_ADDED": "Senast tillagda",
    "TOP_SLOTS": "Bästa slotsen",
    "VIRTUAL_SPORTS": "Virtuell Sport",
    "INFO_TITLE_ARENA_VIRTUAL_SPORTS": "Virtuell Sport",
    "INFO_TEXT_ARENA_VIRTUAL_SPORTS": "Virtuell Sport ger dig ett brett urval av datorgenererade sporter som du kommer kunna spela på dygnet runt. Så varför vänta på den där stora matchen ikväll när du kan spela på virtuella matcher när du vill?",
    "MINI_ORBIT_BALANCE": "Saldo:",
    "REAL_MONEY_GAME": "Du kan endast spela det här spelet med ditt kontantsaldo.",
    "NEW_GAMES_LIST_TITLE": "Nya online casinospel",
    "NEW_GAMES": "Nya spel",
    "TOP_EXCLUSIVE_SLOTS": "Top exclusieve speelautomaten",
    "TOP_10_IN_YOUR_COUNTRY": "Top 10 in uw land",
    "CANT_CONNECT_ERROR_TITLE": "Kan inte ansluta",
    "CANT_CONNECT_ERROR_MESSAGE": "Tyvärr inträffade ett fel hos oss.",
    "RETRY": "FÖRSÖK IGEN",
    "TRANSACTION_HISTORY": "Transaktionshistorik",
    "HOTTEST_NEW_GAMES": "Hetaste nya spelen",
    "BRAND_NEW": "Splitternytt",
    "SINCE_LAST_MONTH": "Sedan förra månaden",
    "SAFE_GAMBLING_TOOLTIP": "Säkrare Betting Verktyg & Information",
    "GAME_POPUP_GAME_UNAVAILABLE": "Tyvärr är det här spelet inte tillgängligt",
    "GAME_POPUP_MAY_LIKE": "Du skulle kanske också gilla:",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE": "HURRA! Du står i begrepp att börja spela ett {partyJackpotName}-spel.",
    "PARTY_JACKPOT_WELCOME_POPUP_TITLE_ALL_LIVE_CASINO": "LUCKY YOU!",
    "PARTY_JACKPOT_WELCOME_POPUP_SUB_TITLE_ALL_LIVE_CASINO": "All Live Casino games are part of our HOT NEW jackpot!",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION": "Jackpotten kan vinnas på alla typer av satsningar som görs med kontantsaldot.\nAlla priser från vår Party Jackpot är bonusar som direkt sätts in på ditt konto.",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL": "Alla satsningar med riktiga pengar på ett spel med Party Jackpot kan belönas med ett kontantpris.\nVår Party Jackpot betalas ut dagligen.",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY": "Any real money bet on a Party Jackpot game could win a cash prize!\nThe Party Jackpot will pay hourly between {startHour} to {endHour}",
    "PARTY_JACKPOT_WELCOME_POPUP_DESCRIPTION_REAL_HOURLY_ALL_LIVE_CASINO": "Real money bets on any Live Casino game could win the jackpot! The Live Casino Jackpot must pay every hour, {startHour} - {endHour}, and is fully funded by us.",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE": "Bonus: omsätt 30x (varierar beroende på speltyp), 90 dagar giltighetstid, vinster begränsas vid $500, giltigt för utvalda spel",
    "PARTY_JACKPOT_WELCOME_POPUP_BOTTOM_NOTE_REAL": "Endast spelare med saldo",
    "PARTY_JACKPOT_WELCOME_POPUP_TERMS_AND_CONDITIONS_APPLY": "Villkor gäller.",
    "PARTY_JACKPOT_WIN_TOASTER_TITLE": "{jackpotName} betalade precis {winAmount}!",
    "PARTY_JACKPOT_WIN_TOASTER_SUBTITLE": "Vann du inte? Ingen fara.\n Denna jackpot betalas ut varje timme, {startHour}-{endHour}",
    "PARTY_JACKPOT_WIN_POPUP_YOU_WON": "DU HAR VUNNIT {jackpotName}",
    "PARTY_JACKPOT_WIN_POPUP_AWESOME": "UNDERBART.",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_TITLE": "Sätt in för att spela Live Casino-jackpotten",
    "PARTY_JACKPOT_OUT_OF_CASH_TOASTER_SUBTITLE": "Live Casino-jackpotten kan endast vinnas med riktiga pengar",
    "JACKPOT-WIDGET-MUST-PAY": "Måste falla ut inom:",
    "JACKPOT-WIDGET-DROPS-SOON": "FALLER UT SNART!",
    "JACKPOT-WIDGET-STARTS-SOON": "STARTAR SNART",
    "JACKPOT-WIDGET-NEXT-JACKPOT": "Nästa jackpott inleds",
    "JACKPOT-WIDGET-LAST-WIN": "Senaste vinst",
    "IN-GAME-WIDGET-STARTS-SOON": "Startar snart",
    "FREEPLAY_INDICATOR": "FreePlay",
    "OMG_INDICATOR": "Meddelanden",
    "USER_LIKE_YOU": "TOPP {topNumber} I {countryName}",
    "YOUR_COUNTRY": "Ditt land",
    "CLOSE": "Stäng",
    "LIVE_STREAM_WATCH_TIME_REACHED": "Redo att delta och spela?",
    "LIVE_STREAM_VIDEO_LOADING": "Laddar...",
    "PLAY_NOW": "SPELA",
    "CASINO": "CASINO",
    "PAYMENTS_REDIRECT_FOCUS_TITLE": "Insättningen behandlas",
    "PAYMENTS_REDIRECT_FOCUS_TEXT": "Din {mftName} skärm är fortfarande öppen",
    "PAYMENTS_REDIRECT_FOCUS_CTA": "Fortsätt",
    "VOLATILE_SLOTS": "Volatila Slots",
    "VOLATILE_GAMES": "Volatila Spel",
    "HIGH_VOLATILITY_SLOTS": "Slots med hög volatilitet",
    "LOW_VOLATILITY_SLOTS": "Slots med låg volatilitet",
    "BURNOUT_MESSAGE_LINE_1": "SURPRISE!",
    "BURNOUT_MESSAGE_LINE_2": "YOU GOT A BONUS!",
    "CONGRATS": "Grattis",
    "YOUR_FP_ARE_WAITING": "Dina FreePlay väntar på dig här",
    "EXIT_POPUP_TITLE": "Du Skulle Kanske Också Gilla",
    "DONT_SHOW_AGAIN_TEXT": "Visa inte detta igen",
    "GAMING_HISTORY_NO_RECORDS": "Vi kunde inte hitta några historikposter för dina spel",
    "GAMING_HISTORY_LAST_PAGE": "Inga ytterligare historikposter hittades.",
    "GAMING_HISTORY_BET": "Insats",
    "GAMING_HISTORY_WINNINGS": "Vinster",
    "GAMING_HISTORY_WINNINGS_BONUS_CAP": "Vinster*",
    "GAMING_HISTORY_BANKROLL": "Spelkonto",
    "GAMING_HISTORY_MORE_DETAILS": "Mer",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_PC": "Endast tillgängligt på mobila enheter",
    "GAMING_HISTORY_MORE_DETAILS_NOT_AVAILABLE_MOBILE": "Endast tillgängligt på PC",
    "GAMING_HISTORY_FREE_PLAY_BET": "Insats*",
    "GAMING_HISTORY_FREE_PLAY_WINNINGS": "Vinst*",
    "GAMING_HISTORY_FREE_PLAY_REWARD_WINNINGS": "Belöningsvinster",
    "GAMING_HISTORY_FREE_PLAY_REWARD_BANKROLL": "Spelkontobelöning",
    "GAMING_HISTORY_FREE_PLAY_INDICATION": "* Spelat med belöningar.",
    "GAMING_HISTORY_FREE_PLAY_MAX_CUP_INDICATION": "* Maximal vinst.",
    "GAMING_HISTORY_DAYS_INTERVAL": "Senaste {numberOfDays} dagarna",
    "GAME_PARTICIPATION_ID": "Deltagande-ID: {participationID}",
    "GAME_SESSION_ID": "Sessions-ID {sessionID}",
    "TSR_MENU_LINK_LABEL": "Tid spenderad påminnelse",
    "TSR_CONFIRM": "Fortsätt",
    "TSR_CLOSE_GAME": "Stäng spelet",
    "TSR_TITLE": "Påminnelse",
    "TSR_SESSION_TIME_TEXT": "Du har varit inloggad i:",
    "TSR_WINNINGS_TEXT": "Total vinst:",
    "TSR_LOSSES_TEXT": "Total förlust:",
    "GAME_WINDOW_VENDOR_SESSION_ID": "Sessions-ID {sessionID}",
    "GAME_WINDOW_MODE_REAL_LABEL": "Spel om pengar",
    "GAME_WINDOW_MODE_DEMO_LABEL": "Övningsspel",
    "FREE_PLAY_VOUCHER_NAME_FPV": "FreePlay",
    "FREE_PLAY_VOUCHER_NAME_FSV": "Free spins",
    "FREE_PLAY_VOUCHER_NAME_JPFPV": "Jackpott-FreePlay",
    "FREE_PLAY_VOUCHER_NAME_JPFSV": "Jackpott-spins",
    "FREE_PLAY_VOUCHER_BALANCE_PREFIX": "Återstående:",
    "FREE_PLAY_VOUCHER_TITLE_FPV": "FreePlay-belöning",
    "FREE_PLAY_VOUCHER_TITLE_FSV": "Freespins-belöning",
    "FREE_PLAY_VOUCHER_TITLE_JPFPV": "Jackpott-FreePlay-belöning",
    "FREE_PLAY_VOUCHER_TITLE_JPFSV": "Jackpottsdragningsbelöning",
    "FREE_PLAY_VOUCHER_DESC_FPV": "FreePlay-pengar att använda på utvalda spel när du vill!",
    "FREE_PLAY_VOUCHER_DESC_FSV": "Free spins med fördefinierade värden att använda på utvalda spel!",
    "FREE_PLAY_VOUCHER_DESC_JPFPV": "Endast jackpott-FreePlay-pengar att använda på utvalda spel när du vill!",
    "FREE_PLAY_VOUCHER_DESC_JPFSV": "Endast jackpott-free spins med fördefinierade värden att använda på utvalda spel!",
    "FREE_PLAY_VOUCHER_REWARD_AMOUNT": "{amount} {fp_voucher_name}",
    "FREE_PLAY_VOUCHER_REWARD_BALANCE": "{fp_voucher_remaining_prefix} {balance}",
    "FREE_PLAY_EXPIRES_IN_TIME": "Löper ut om {expiration}",
    "FREE_PLAY_EXPIRES_IN_EXPIRED": "Utgången",
    "FREE_PLAY_EXPIRES_IN_DAY": "Löper ut om {expiration} dagar",
    "FREE_PLAY_MESSAGE_VOUCHER_TITLE_GOOD_LUCK": "Lycka till!",
    "FREE_PLAY_MESSAGE_LIST_TITLE": "Du har belöningar som ligger och väntar. Lycka till!",
    "FREE_PLAY_MESSAGE_SELECTED_GAME_TITLE": "Du kan satsa i det här spelet med hjälp av följande belöningar:",
    "FREE_PLAY_MESSAGE_GAMES_LIST_TITLE": "Du kan använda den här belöningen i följande spel:",
    "FREE_PLAY_MESSAGE_NO_VOUCHERS": "Du har inga belöningar för närvarande",
    "FREE_PLAY_MESSAGE_BACK_TO_VOUCHERS": "Tillbaka",
    "FREE_PLAY_SHOW_MORE": "Visa Fler",
    "FREE_PLAY_SHOW_LESS": "Visa Mindre",
    "FREE_PLAY_USE_NOW_BUTTON": "Använd nu",
    "FREE_PLAY_USE_LATER_BUTTON": "Använd senare",
    "FREE_PLAY_SUGGESTION_DIALOG_TITLE": "Du har belöningar i detta spel!",
    "IDLE_RECOMMENDATIONS_TITLE": "Kan du inte bestämma dig för vad du ska spela?",
    "IDLE_RECOMMENDATIONS_SECOND_TITLE": "Vad sägs om:",
    "BONUS_ABUSE_PREVENTION_TITLE": "Frånkopplat spel",
    "BONUS_ABUSE_PREVENTION_MESSAGE": "Det ser ut som om det finns ett spel som kopplades bort....\n Vänligen avsluta {gameName} innan du börjar spela {newGameName}.",
    "BONUS_ABUSE_PREVENTION_NOT_NOW_BTN": "Inte nu",
    "BONUS_ABUSE_PREVENTION_COMPLETE_BTN": "Avsluta spel",
    "OPEN_GAME_FROM_CHALLENGES": "Utmaningar kan inte genomföras med hjälp av belöningar.",
    "CANCEL": "Avbryt",
    "YES": "JA",
    "NO": "Nej",
    "ONE_GAME_PER_SESSION_DIALOG_TITLE": "Öppet spel",
    "ONE_GAME_PER_SESSION_DIALOG_MESSAGE": "Det verkar som om ett spel fortfarande är öppet.\n Vill du avsluta {oldGameName} och börja spela {newGameName}?",
    "GAMES_OF_THE_WEEK": "Games Of The Week",
    "THE_FISH_MARKET": "The Fish Market",
    "LETS_PLAY_POKER": "Lets Play Poker!",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_TITLE": "Långsam uppkoppling",
    "HYBRID_EMBEDDED_GAME_LOADING_SLOW_CONNECTION_TOASTER_SUBTITLE": "i har identifierat en långsam nätverksuppkoppling. Det kan därför ta lite längre än förväntat att öppna spelet.",
    "HYBRID_EMBEDDED_GAME_LOADING_SPINNER_LABEL": "Ansluter...",
    "HYBRID_EMBEDDED_GAME_LOADING_PACKAGES_PROGRESS": "Förbereder spel {packagesStatus}",
    "HELP_CENTER": "Hjälpcenter",
    "ABOUT_TITLE": "Dina kontouppgifter",
    "ABOUT_SUPPORT_ID_TITLE": "Support-ID",
    "ABOUT_CLIENT_VERSION_TITLE": "Klientversion",
    "ABOUT_HELP_SUPPORT": "Se onlinehjälpen om du har några supportfrågor.",
    "ABOUT_OPEN_SESSION_TITLE": "Om & oavslutade spel",
    "OK": "OK",
    "INSUFFICIENT_FUNDS_TITLE": "Otillräckligt saldo",
    "INSUFFICIENT_FUNDS_MESSAGE": "Ditt nuvarande saldo räcker inte för det här spelet. Du måste göra en insättning i kassan för att kunna fortsätta spela.",
    "OPEN_CASHIER": "Öppna kassan",
    "GAME_LIMIT_REAL_MONEY_WARNING_MESSAGE": "Du kan endast spela det här spelet med ditt kontantsaldo.",
    "SUGGEST_REAL_MODE_DIALOG_TITLE": "Demospel",
    "SUGGEST_REAL_MODE_DIALOG_TEXT": "Notera att {game_name} kommer att öppnas i demoläge.<br><br>Om du vill spela för riktiga pengar behöver du registrera dig eller logga in.",
    "PLAY_DEMO": "Spela demo",
    "GAME_NET_POSITION_LABEL": "Spelsaldo",
    "GAME_DURATION_LABEL": "Spellängd",
    "GAME_LIMIT_TITLE": "Välj pengarna i spelet",
    "REGULATORY_LIMIT_LABEL": "Föreskrivande gräns",
    "OTHER_LIMIT_LABEL": "Övrigt",
    "GAME_LIMIT_VALUE_ERROR": "Ogiltigt belopp. Försök igen",
    "GAME_LIMIT_REGULATION_ERROR": "Maximalt belopp är {regulationLimit}. Försök igen.",
    "GAME_LIMIT_MIN_BET_ERROR": "Belopp understiger bordsminimum. Försök igen",
    "Adventure": "Äventyr",
    "Ancient Civilization": "Forntida civilisation",
    "Arabic": "Arabiskt",
    "Asian": "Asiatiskt",
    "Classic Style": "Klassisk stil",
    "Comics and Cartoons": "Tecknade serier",
    "Diamonds and Gems": "Diamanter och ädelstenar",
    "Egyptian": "Egyptiskt",
    "Fantasy and Folklore": "Fantasy och folklore",
    "Farm and Pets": "Bondgård och husdjur",
    "Fish": "Fiskar",
    "Fruit and Candy": "Frukt och godis",
    "Greek Mythology": "Grekisk mytologi",
    "Irish": "Irländskt",
    "Money and Leisure": "Pengar och fritid",
    "Movies and Music": "Filmer och musik",
    "Seasonal": "Säsongsbetonat",
    "Space and Sci-fi": "Rymd och science fiction",
    "Wildlife": "Djur- och växtliv",
    "GAME_STUDIOS": "Spelstudior",
    "THEMES": "Teman",
    "GAME_FEATURES": "Funktioner",
    "GAME_CATEGORIES": "Kategorier",
    "FILTER_BY": "Filtrera efter",
    "NO_JACKPOT": "Ingen jackpott",
    "HIGH_STAKES": "Höga insatser",
    "LOW_STAKES": "Låga insatser",
    "MULTIHAND": "Multihand",
    "LIVE_BACCARAT": "Live Baccarat",
    "LIVE_POKER": "Livepoker",
    "LIVE_GAME_SHOWS": "Livespelprogram",
    "CRAPS": "Craps",
    "LIVE_ROULETTE": "Live Roulette",
    "MEDIUM_VOLATILITY": "Medelhög volatilitet",
    "VOLATILITY": "Volatilitet",
    "ONBOARDING_WELCOME_STEP_MAIN_TEXT": "",
    "ONBOARDING_WELCOME_STEP_SECONDARY_TEXT": "",
    "ONBOARDING_MENU_STEP_MAIN_TEXT": "",
    "ONBOARDING_MENU_STEP_SECONDARY_TEXT": "",
    "ONBOARDING_USER_AREA_MAIN_TEXT": "",
    "ONBOARDING_USER_AREA_SECONDARY_TEXT": "",
    "NEXT": "Nästa",
    "DONE": "Klart",
    "SPEED_GAMES": "hastighetsspel",
    "MDP_INACTIVITY_DISCONNECTED_TITLE": "Meddelande",
    "MDP_INACTIVITY_DISCONNECTED_TEXT": "Du har loggats ut på grund av inaktivitet.",
    "RICH_USER_NOT_LOGGED_IN": "För att se dina utmaningar, vänligen logga in",
    "CONTROL_CENTER_ONBOARDING_TOOLTIP_TEXT": "Ställ in dina gränser, se din aktivitetsstatistik och mer i kontrollcentret!"
  }
}